var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campaing-form-container"},[_c('Table',{attrs:{"columns-data":_vm.columns,"data":_vm.campaigns,"load-data":_vm.loadData,"pagination-data":_vm.paginationData,"column-sort":_vm.sort,"checkbox-enable":true,"search-data":_vm.searchData,"buttons":[
      {
        name: _vm.$t('pages.campaigns.topBar.createButton'),
        class: 'btn-blue btn-create-campaign',
        route: _vm.getCreateCampaignRoute,
        action: _vm.selectGroupPopup,
      } ],"checkbox-actions":[
      {
        name: 'Move',
        action: _vm.moveToGroup,
      } ]},on:{"loadData":_vm.getCampaigns,"deleteRow":_vm.deleteCampaign,"editRow":_vm.editCampaign,"cloneRow":_vm.cloneCampaign,"changeStatus":_vm.changeStatusCampaign},scopedSlots:_vm._u([{key:"bodyRowTd",fn:function(rowProps){return [(rowProps.dataColumn.field === 'group')?_c('div',[_c('router-link',{attrs:{"to":{
            name: 'UpdateCampaignGroup',
            params: {
              id: rowProps.dataRow.group.id,
            },
          }}},[_vm._v(" "+_vm._s(rowProps.dataRow.group.name)+" ")])],1):(rowProps.dataColumn.field === 'country_codes')?_c('div',{staticClass:"flex items-center"},[_vm._v(" "+_vm._s(_vm.getCountries(rowProps.dataRow.country_codes))+" "),_c('InfoHint',{attrs:{"message":_vm.createCountryPopoverMessage(
              rowProps.dataRow.geo_type,
              rowProps.dataRow.geo_values
            )}})],1):_vm._e()]}}])}),_c('SelectGroupPopup',{ref:"selectGroupPopup",on:{"change":_vm.changeGroup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }